















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Md5 } from 'md5-typescript';
import HelpIcon from 'vue-material-design-icons/Help.vue';
import moment from 'moment';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { EnergyDisplay } from '../interfaces';

@Component({
    components: {},
})
export default class MyNeighbourhood extends Vue {

    private clockHandler: any;
    private notifications: string[] = ['Parking at Riverdale', 'support for Riverdale residents', 'TODAY: ParkRun', 'Brompton Bike - availabe free of charge'];
    public created() {
        // this.clockHandler = setInterval(function(parent) {
        //   this.update();
        // }.bind(this), 30000);
    }

    public async mounted() {

        return;
    }
}
